import React from 'react';
import _get from 'lodash/get';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Chip, { ChipSizes, ChipTypes } from '@lib/components/Chip/Chip';
import { SelectPanelOptionRendererProps } from '../types';
import { getOptionLabel } from '../utils';
import styles from '../SelectPanel.module.scss';

export function ChipOption({
  option,
  isSelected,
  isMulti,
}: SelectPanelOptionRendererProps): React.ReactElement {
  const { t } = useTranslation();
  const color =
    _get(option, ['data', 'color']) ||
    _get(option, 'color') ||
    ChipTypes.chipGray;
  const leftIcon = _get(option, ['data', 'leftIcon'], 'circle');
  const leftIconComponent = _get(option, ['data', 'leftIconComponent']);
  const leftIconSize = _get(option, ['data', 'leftIconSize']);
  const leftIconSymbolsOutlined = _get(option, [
    'data',
    'leftIconSymbolsOutlined',
  ]);

  return (
    <div
      className={classNames(
        styles.chipCircleOption,
        styles.entityOptionWithLeftIcon,
        {
          active: isSelected,
          [styles.optionWithCheckbox]: isMulti,
        },
      )}
    >
      {isMulti && (
        <span className={styles.optionCheckbox}>
          <MaterialIcon
            icon={isSelected ? 'check_box' : 'check_box_outline_blank'}
            size="md-18"
          />
        </span>
      )}
      <span className={styles.chipOptionIcon}>
        <Chip
          leftIcon={leftIconComponent ? undefined : leftIcon}
          leftIconSize={leftIconSize}
          leftIconComponent={leftIconComponent}
          type={color}
          size={ChipSizes.smallLeftIconOnly}
          leftIconSymbolsOutlined={leftIconSymbolsOutlined}
        />
      </span>
      {getOptionLabel(option, t)}
    </div>
  );
}
